import axios from 'axios';
import { authHeader } from '../utils/tokenUtils';

const BASE_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:8080'}/api/auth`;

export const getMyOrders = () => axios.get(`${BASE_URL}/my/orders`, authHeader());
export const getMyAddresses = () => axios.get(`${BASE_URL}/my/addresses`, authHeader());
export const addAddress = (data) => axios.post(`${BASE_URL}/my/addresses`, data, authHeader());
export const setDefaultAddress = (addressId) => axios.patch(`${BASE_URL}/my/addresses/${addressId}/default`, {}, authHeader());
export const deleteAddress = (addressId) => axios.delete(`${BASE_URL}/my/addresses/${addressId}`, authHeader());